// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".negative-offset[data-v-5ed9cc20] {\n  outline-offset: -1px;\n}\n.limit-width[data-v-5ed9cc20] {\n  width: calc(100vw - 2rem);\n  /* We need a static width for the tabs container so that there is no horizontal scroll on the page */\n  /* The padding on both side is being accounted for in the width calculation */\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
